import { Component } from '@angular/core';
import { OpenAIService } from 'src/app/services/AI/open-ai.service';
import { UiTranslationService } from 'src/app/services/ui-translation.service';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.css']
})
export class ChatComponent {
  isOpen: boolean = false;
  message: string = "";
  messages: any = 
  [
    {
      translationKey: "chat.welcome",
      tipoMensaje: 1
    }
  ]

  constructor(private openAi: OpenAIService, public i18n: UiTranslationService){}
  
  toggleChat() {
    this.isOpen = !this.isOpen;
  }

  addMessage(){
    let obj = {
      mensaje: this.message,
      tipoMensaje: 2,
    };
    this.message = "";

    this.messages.push(obj);
    this.callGTP(obj.mensaje);
  }

  callGTP(mensaje: string){
    let obj = {
      mensaje: "",
      tipoMensaje: 3,
    };
    this.messages.push(obj);

    this.openAi.sendChat(mensaje).subscribe((response:any) => {
      if(response){
        this.messages = this.messages.filter((mensaje:any) => mensaje.tipoMensaje !== 3);
        response = response.split('-');
        let obj = {
          mensaje: response[1] || this.i18n.translate('chat.noContent'),
          tipoMensaje: 1,
        };
        this.messages.push(obj);
      }
    });
  }
}
